import { styled } from 'styled-components';

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;

export const PaginationContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const LinesPerPage = styled.span`
  margin-right: 10px;
  font-size: 16px;
`;

export const SelectLinesPerPage = styled.select`
  margin-right: 10px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  justify-content: center;
  padding: 5px 10px;
  text-align: left;
  vertical-align: middle;
  min-height: 30px;
  min-width: 30px;
`;

export const DivLinesPerPage = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;
